import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./img.css";
import LatestUpdates from "./latestupdates";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';


const ContentSection = () => (
    <Col md={8}>
        <h2>New Zealand Student Visa</h2><br /><br />
        <h3 className="fw-bold text-decoration-underline"><b>Why Study in New Zealand ?</b></h3>
        <p>
            New Zealand’s educational institutions are well regarded throughout the world, a safe and
            friendly learning environment, a wealth of cultural heritage and tradition, a sub tropical
            climate, and stunning landscape. There is a great range of opportunities available to
            international students. New Zealand offers quality higher education, technical education,
            a well established network of internationally respected and recognized tertiary education providers.
            All provinces and capital cities of different states of New Zealand have established institutes like –
            Dunedin, the capital of the Otago region has the deserved reputation as the country’s ‘Student City’
            and is home to 25,000 students, giving the City a special character and a dynamic, vibrant atmosphere.
            2250 international students from more than 75 countries worldwide choose to study in Dunedin each year.
        </p>
        <h4>BENEFITS OF STUDYING IN NEW ZEALAND</h4>
        <p>Combining the benefits of a developed country with the charm of a quiet and peaceful countryside, New
            Zealand offers some distinct advantages over other countries as a destination for education.</p>

        <ul>
            <li>Get an international standard education and have the best period of your life.</li>
            <li>An important one of which is the affordability – getting a degree in NZ actually
                works out to be cheaper than many courses in India.</li>
            <li>Another significant advantage is the welcoming nature of the New Zealanders and the relative ease in getting there.
                NZ has recently opened its doors to students from South East Asia.</li>
            <li>The Immigration opportunities in New Zealand after completion of the study program is one of the many advantages
                that a prospective student can expect.</li>
            <li>The student can take his/her spouse and the the spouse can work in New Zealand for the duration of the student visa while
                the student can can work for 20 hours during the term and for full time during the scheduled breaks.</li>
            <li>The choice of courses in New Zealand is vast and settlement opportunities for courses like trade diplomas in electrical,
                Plumbing, Refrigeration and air-conditioning, welding, machinist and tool and die makers is excellent.</li>
            <li>The teachers categories and food production professionals are also one of the most sought after courses in New Zealand.
                The student gets points for immigration purpose and the settlement rules and regulations are also very easy.</li>
        </ul>
        <br /><br />
        <h4>NEW ZEALAND STUDY VISA REQUIREMENTS/ ELIGIBILITY</h4>
        <p>Planning to study in New Zealand requires meeting certain requirements. If you are planning to study in New Zealand for more than
            three months you are supposed to have study visa for that purpose. Student visa requirement includes:</p>
        <ul>
            <li>An offer from the university or college you are planning to pursue your course.</li>
            <li>A written guarantee of the accommodation which would be available to you for your entire stay in New Zealand.</li>
            <li>The evidence of funds which you would be using to support your stay in New Zealand.</li>
            <li>A return air ticket to your country, or evidence of the funds to buy one.</li>
            <li>You are liable to get the test of tuberculosis done if your stay there is beyond six months.</li>
            <li>The verification by the police of good character is mandatory when your age is more than 17.
                You will be issued a police certificate of a good character.</li>
        </ul>
        <p>If your plans are long term that is you would like to work here too then you need to know the 
            requirements of work here and after study, you could pursue what you are looking forward to 
            providing your visa tenure permits you to do the same. Dependent work children also need a student visa.
             To avoid any delay students are advised to apply for the visa from their home country.</p>
             <br /><br />
             <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
    </Col>
);






const Sidebar = () => (
    <Col md={3}>
            <Col md={12}>
              <div style={{ maxWidth: "800px", width: "100%" }}>
                  <Card className="border-0 shadow-none">
                  <Card.Header className="fw-bold">Latest Posts</Card.Header>
                      <ListGroup variant="flush">
                          <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                          <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                          <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                          <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                          <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                          {/* <ListGroup.Item className="border-0"><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */}
                          <ListGroup.Item className="border-0"><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
                      </ListGroup>
                  </Card>
              </div>
          </Col>

        {/* YouTube & Social Media Section */}
        <Card className="p-3 text-center mt-4"> {/* Added spacing between sidebar and card */}
            <Image src="./img/brand-logo.png" alt="Bajwa Immigration Logo" fluid className="mb-3" />

            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets" >SUBSCRIBE</a></Button>

            <h6 className="fw-bold">Book Consultation</h6>
            <Button variant="warning">BOOK CONSULTATION</Button>

            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="100%"
                height="130"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
            ></iframe>

            <h6 className="fw-bold mt-3">We are also on:</h6>
            <div className="d-flex justify-content-center gap-3">
                <FaInstagram size={30} color="#C13584" />
                <FaTiktok size={30} color="#000" />
                <FaYoutube size={30} color="crimson" />
            </div>
        </Card>
    </Col>
);


const NZVisa = () => (
    <>
        <Container className="mt-4">
            {/* <HeroSection /> */}
            <Row className="mt-4 gap-4"> {/* Added gap-4 for spacing between content and sidebar */}
                <ContentSection />
                <Sidebar />

            </Row>
        </Container>
       
        
        <LatestUpdates />
        <Footer />
    </>
);

export default NZVisa;
